<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <button @click="onBack" class="btn btn bg-utel-v2-secondary text-primary mb-3">
            <strong>
                <i class="fa fa-arrow-left"></i>
                Regresar
            </strong>
        </button>

        <h1 style="color: #424148;font-weight: bold;font-size: 36px;">
            Colaboradores
        </h1>
        <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
            <div class="justify-content-star d-flex">
                <h3><strong style="color:#1A0054">Fidelización y retención de talento</strong></h3>
            </div>
            <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                <search-input-component :search="search" @onSearch="onFilterSearch($event)"></search-input-component>

                <a href="" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descargar
                    reporte</a>
            </div>
        </div>
        <v-data-table
                :headers="headersTabs"
                :items="users"
                item-key="name"
                :search="search"
                :page="page"
                :items-per-page="itemsPerPage"
                class="elevation-1 table text-center align-middle small"
                loading
                loading-text="Cargando..."
                mobile-breakpoint="0"
                :header-props="{
                    sortIcon: 'fa-solid fa-sort-amount-desc'
                }"
                :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50]
                }"
                hide-default-footer
            >
                <template v-slot:item="row">
                    <tr class="text-center">
                        <td>{{ row.item.id }}</td>
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.email }} </td>
                        <td>{{ row.item.start_date || '-' }}</td>
                        <td>{{ row.item.end_date || '-'}} </td>
                        <td>
                            <span class="badge px-4 py-2 badge-doing rounded-2" :class="{'badge-completed': !!row.item.graduation}">
                                {{ !!row.item.end_date ? 'Completado' : 'En curso' }}
                            </span>
                        </td>
                    </tr>
                </template>
                <template v-slot:footer>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount" :total-visible="6" next-icon='fas fa-angle-right'
                            prev-icon='fas fa-angle-left'></v-pagination>
                    </div>
                </template>
            </v-data-table>
    </div>
</template>
<script>
    export default {
        props: ['url', 'course'],
        data(){
            return {
                search: '',
                headersTabs: [
                    { text: "No.", value: "id" },
                    { text: "Nombre", value: "name" },
                    { text: "Correo", value: "email" },
                    { text: "Inicio", value: "start_date"},
                    { text: "Finalización", value: "end_date"},
                    { text: "Estado", value: "status"}
                ],
                users: [],
                page: 1,
                itemsPerPage: 10
            }
        },
        computed: {
            pageCount() {
                return Math.ceil(this.users.length / this.itemsPerPage)
            },
        },
        mounted(){
            this.getData();
        },
        methods: {
            onFilterSearch(searchText) {
                this.search = searchText;
            },
            onBack(){
                this.$emit('onBack');
            },
            getData(){
                axios.post(this.url, { course: this.course }).then((res)=>{
                    this.users = res.data.users;
                })
            }
        }
    }
</script>
<style>
    .badge-completed{
        background-color: #C6F6D5;
        color: #1C4532;
        font-size: 14px;
    }

    .badge-doing{
        background-color: #CBD5E0;
        color: #2D3748;
        font-size: 14px;
    }
</style>
